import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import styles from "./styles/Inbox.module.scss";
import { CardTitle, Input } from "../../Components/CustomComponents";

import { FiSend } from "react-icons/fi";
import { IoIosArrowBack } from "react-icons/io";
import { useSocket } from "../../Context/SocketContext";
import { useSelector } from "react-redux";
import { useChatContext } from "./Context/ChatContext";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { ErrorToast } from "../../Hooks/useToast";
import { getMessageTime } from "../../Helper";
import { Form, Spinner } from "react-bootstrap";
import DeleteModal from "../../Components/Modals/DeleteModal";
import { FaTrashAlt } from "react-icons/fa";

export default function Inbox({ isMobile = false }) {
  const socket = useSocket();
  const { isSocketConnected, user } = useSelector((state) => state.authInfo);
  const { setChatRoom, chatRoom, updateLastMessagePayload } = useChatContext();

  //   console.log(chatRoom);

  const INITIAL_CHAT_HISTORY = useMemo(() => {
    return {
      isError: false,
      isLoading: true,
      data: [],
    };
  }, []);

  const chatContainerRef = useRef(null);
  const popupRef = useRef(null);
  const messageRef = useRef();
  const popoverRef = useRef(null);

  const [page, setPage] = useState(1);
  const [chatHistory, setChatHistory] = useState(INITIAL_CHAT_HISTORY);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [editGroupModal, setEditGroupModal] = useState(false);
  const [isMessageDeleteModal, setMessageDeleteModal] = useState(false);
  const [media, setMedia] = useState(undefined);
  const [popupData, setPopupData] = useState({});
  const [message, setMessage] = useState();

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setIsPopoverOpen(false);
    }

    if (popupRef.current && !popupRef.current.contains(event.target)) {
      popupRef.current.style.display = "none";
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleBackButtonClick = () => {
    setChatRoom({});
  };

  useEffect(() => {
    if (isSocketConnected) {
      socket.on("loadChatHistory_", (data) => {
        setChatHistory((prev) => {
          return {
            ...prev,
            isLoading: false,
            data: data?.data || [],
          };
        });
      });
      socket.on("deleteChatMessage_", (data) => {
        setChatHistory((prev) => {
          return {
            ...prev,
            data: prev.data.filter(
              (item) => item.message_slug !== data.payload.message_slug
            ),
          };
        });
      });
    }

    return () => {
      if (isSocketConnected) {
        socket.dispose("loadChatHistory_");
        socket.dispose("deleteChatMessage_");
      }
    };
  }, [isSocketConnected]);

  useEffect(() => {
    if (isSocketConnected) {
      socket.on("receivedMessage_", (data) => {
        const message = data?.data;
        if (message?.chat_room_slug !== chatRoom.slug) return;
        if (message.user_slug !== user.slug) {
          setChatHistory((prev) => {
            return {
              ...prev,
              data: [...prev?.data, message],
            };
          });
        } else {
          if (_.isUndefined(data?.payload?.message_uuid)) {
            setChatHistory((prev) => {
              return {
                ...prev,
                data: [...prev?.data, message],
              };
            });
          } else {
            setChatHistory((prev) => {
              return {
                ...prev,
                data: [
                  ...prev?.data.filter(
                    (item) => item.message_uuid !== data?.payload.message_uuid
                  ),
                  message,
                ],
              };
            });
          }
        }
        updateLastMessagePayload(message);
        socket.emit("_resetMessageCount", { chat_room_slug: chatRoom.slug });
      });
    }

    return () => {
      if (isSocketConnected) {
        socket.dispose("receivedMessage_");
      }
    };
  }, [isSocketConnected, chatRoom]);

  useEffect(() => {
    if (!_.isEmpty(chatRoom) && page > 1) {
      socket.emit("_loadChatHistory", { chat_room_slug: chatRoom.slug });
    }
  }, [page]);

  useEffect(() => {
    if (!chatHistory.isLoading) {
      setChatHistory(INITIAL_CHAT_HISTORY);
    }

    if (!_.isEmpty(chatRoom)) {
      socket.emit("_loadChatHistory", { chat_room_slug: chatRoom.slug });
    }
  }, [chatRoom]);

  const scrollChatContainer = () => {
    const container = document.getElementById("chatContainer");
    container.scroll({ top: container.scrollHeight, behavior: "smooth" });
  };

  useEffect(() => {
    scrollChatContainer();
  }, [chatHistory?.data.length]);

  const handleSendMessage = async () => {
    const message = messageRef.current.value;
    if (!message && _.isUndefined(media)) return;

    try {
      const payload = {};

      //   if (!_.isUndefined(media)) {
      //     const formData = new FormData();
      //     formData.append("file", media);
      //     const res = await axios({
      //       method: "POST",
      //       url: UPLOAD_URL,
      //       data: formData,
      //       headers: {
      //         Token: INITIAL_TOKEN,
      //         "Content-Type": "multipart/form-data",
      //       },
      //     });

      //     payload.message_type = MESSAGE_TYPE_ENUM.FILE;
      //     payload.file_type = getFileType();
      //     payload.file_name = media.name;
      //     payload.file_url = res?.data?.data?.link;
      //   } else {
      payload.message_type = "TEXT";
      //   }
      payload.chat_room_slug = chatRoom.slug;
      payload.message = message;
      payload.message_uuid = uuidv4();
      setChatHistory((prev) => {
        return {
          ...prev,
          data: [
            ...prev?.data,
            {
              ...payload,
              user_slug: user.slug,
              user_name: user.name,
              user_image: user.image_url,
              message_timestamp: new Date(),
            },
          ],
        };
      });
      socket.emit("_sendMessage", payload);
      messageRef.current.value = "";
      setMedia(undefined);
    } catch (err) {
      ErrorToast(err?.message);
    }
  };

  //   const showPopup = (event, data = {}) => {
  //     event.preventDefault();

  //     console.log(event);
  //     console.log(data);

  //     if (!popupRef.current || !chatContainerRef.current) return;

  //     const chatItem = event.currentTarget;
  //     const itemRect = chatItem.getBoundingClientRect();
  //     const containerRect = chatContainerRef.current.getBoundingClientRect();

  //     const top =
  //       itemRect.top - containerRect.top + chatContainerRef.current.scrollTop;
  //     const popupHeight = popupRef.current.offsetHeight;

  //     setPopupData(() => {
  //       return {
  //         slug: data.message_slug,
  //       };
  //     });
  //     popupRef.current.style.display = "block";
  //     // if (top - popupHeight < 0) {
  //     //   popupRef.current.style.top = `${top + chatItem.offsetHeight}px`; // Show below the chat item
  //     // } else {
  //     //   popupRef.current.style.top = `${top - popupHeight}px`; // Show above the chat item
  //     // }
  //     // if (chatItem.classList.contains("me")) {
  //     //   popupRef.current.style.right = `15px`;
  //     // } else {
  //     //   popupRef.current.style.left = `15px`;
  //     // }
  //     setTimeout(() => {
  //       const popupHeight = popupRef.current.offsetHeight;
  //       const top =
  //         itemRect.top - containerRect.top + chatContainerRef.current.scrollTop;

  //       if (top - popupHeight < 0) {
  //         popupRef.current.style.top = `${top + chatItem.offsetHeight}px`;
  //       } else {
  //         popupRef.current.style.top = `${top - popupHeight}px`;
  //       }

  //       if (chatItem.classList.contains("me")) {
  //         popupRef.current.style.right = `15px`;
  //         popupRef.current.style.left = "unset";
  //       } else {
  //         popupRef.current.style.left = `15px`;
  //         popupRef.current.style.right = "unset";
  //       }
  //     }, 0);
  //   };

  const handleDeleteMessage = () => {
    console.log(message);
    socket?.emit("_deleteChatMessage", {
      message_slug: message.message_slug,
      is_fromEveryone: true,
    });
    setMessageDeleteModal(false);
    // setPopupData({});
  };

  const handleMessageModalClose = useCallback(() => {
    setMessageDeleteModal(false);
  }, []);

  const handleMessageModalOpen = (item) => {
    setMessageDeleteModal(true);
    setMessage(item);
  };

  return (
    <div className={styles.Inbox}>
      {isMessageDeleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleMessageModalClose}
          //   data={editedData}
          //   isDeleting={isDeleting}
          onDelete={handleDeleteMessage}
        />
      ) : (
        ""
      )}
      <div className={styles.titleContainer}>
        <div className={styles.userContainer}>
          <div className={styles.imageContainer}>
            {isMobile ? (
              <span
                className={styles.backButton}
                onClick={handleBackButtonClick}
              >
                <IoIosArrowBack />
              </span>
            ) : (
              ""
            )}

            <img
              className={styles.image}
              src={chatRoom.image_url}
              alt="User Profile"
            />
            {/* <span className={styles.online}></span> */}
          </div>
          <div className={styles.nameContainer}>
            <CardTitle text={chatRoom.room_name} classes="lc-1 text-white" />
            {/* <p className={styles.online}>Online</p> */}
          </div>
        </div>
      </div>

      <div
        className={`${styles.chatContainer}`}
        id="chatContainer"
        ref={chatContainerRef}
      >
        {chatHistory?.isLoading ? (
          <span className={styles.noThreads}>
            <Spinner />
          </span>
        ) : _.isEmpty(chatHistory?.data) ? (
          <p className={styles.noThreads}>Empty Inbox</p>
        ) : (
          (chatHistory?.data ?? []).map((item, index) => {
            // console.log(item);
            const isMe = item.user_slug === user.slug;
            return (
              <div
                key={item.slug || item.message_uuid}
                className={`${styles.chat} ${isMe ? styles.me : ""}`}
                // onContextMenu={isMe ? (e) => showPopup(e, item) : () => {}}
              >
                <span className={styles.info}>
                  {getMessageTime(item.message_timestamp)}
                </span>
                <div className={styles.messageWrapper}>
                  {isMe && (
                    <FaTrashAlt
                      className={styles.deleteIcon}
                      //   onClick={() => handleDeleteMessage(item)}
                      onClick={() => handleMessageModalOpen(item)}
                      title="Delete message"
                    />
                  )}
                  <p className={`${styles.message} ${isMe ? styles.me : ""}`}>
                    {item.message || ""}
                  </p>
                </div>

                {isMe ? <span className={styles.info}>Seen</span> : ""}
              </div>
            );
          })
        )}
      </div>

      <div className={styles.messageContainer}>
        <Form.Control
          size="lg"
          className={`mt-1 mb-2  ${styles.messageBar}`}
          placeholder={"Type a message"}
          type="text"
          ref={messageRef}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSendMessage();
              e.stopPropagation();
            }
          }}
        />
        <button
          className={`${styles.sendButton} bg`}
          onClick={handleSendMessage}
        >
          <FiSend />
        </button>
      </div>
    </div>
  );
}
